import cls from "./profileDropdown.module.scss";
import PopoverContainer from "containers/popover/popover";
import { IUser } from "interfaces/user.interface";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import usePopover from "hooks/usePopover";
import Avatar from "components/avatar";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import { profileDropdownLinks } from "./profileDropdownLinks";
import { useAuth } from "contexts/auth/auth.context";
import LogoutCircleRLineIcon from "remixicon-react/LogoutCircleRLineIcon";
import Wallet3LineIcon from "remixicon-react/Wallet3LineIcon";
import Price from "components/price/price";
import { getNearestFloor } from "utils/getNearestFloor";

type Props = {
  data: IUser;
};

export default function ProfileDropdown({ data }: Props) {
  const { t } = useTranslation();
  const [open, anchorEl, handleOpen, handleClose] = usePopover();

  const { logout, isAuthenticated, openAuthModal, openWalletHistory, user } =
    useAuth();
  const handleLogout = () => {
    logout();
    handleClose();
  };

  const actualLinks = !isAuthenticated
    ? profileDropdownLinks.filter((item) => !item.requiredAuth)
    : profileDropdownLinks;

  if (!isAuthenticated) {
    return (
      <button
        type="button"
        className={cls.login}
        onClick={() => openAuthModal()}
      >
        {t("login")}
      </button>
    );
  }

  return (
    <>
      <button className={cls.profileBtn} onClick={handleOpen}>
        <div className={cls.imgWrapper}>
          <Avatar data={data} key={data.img} />
        </div>
      </button>

      <PopoverContainer
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: 40 }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className={cls.wrapper}>
          <button type="button" className={cls.closeIcon} onClick={handleClose}>
            <CloseLineIcon />
          </button>
          <header className={cls.header}>
            <div className={cls.profileImage}>
              <Avatar data={data} key={data.img} />
            </div>
            <div className={cls.naming}>
              <Link href={"/profile"} className={cls.title}>
                {data?.firstname} {data?.lastname?.charAt(0)}.
              </Link>
            </div>
          </header>
          <div className={cls.body}>
            <button
              type="button"
              className={cls.flex}
              key="wallet"
              onClick={() => {
                handleClose();
                openWalletHistory();
              }}
            >
              <Wallet3LineIcon size={24} />
              <div className={cls.text}>
                {t("wallet")}:{" "}
                <span className={cls.price}>
                  <Price number={getNearestFloor(user?.wallet?.price)} />
                </span>
              </div>
            </button>
            {actualLinks.map((item) => (
              <Link
                href={item.href}
                className={cls.flex}
                key={item.href}
                onClick={handleClose}
              >
                {item.icon}
                <span className={cls.text}>{t(item.label)}</span>
              </Link>
            ))}
            <button type="button" className={cls.flex} onClick={handleLogout}>
              <LogoutCircleRLineIcon size={24} />
              <span className={cls.text}>{t("logout")}</span>
            </button>
          </div>
        </div>
      </PopoverContainer>
    </>
  );
}
